export var SearchType;
(function (SearchType) {
    SearchType["Documents"] = "documents";
    SearchType["Clauses"] = "clauses";
})(SearchType || (SearchType = {}));
export var SaveState;
(function (SaveState) {
    SaveState["ERROR"] = "ERROR";
    SaveState["READY_TO_SAVE"] = "READY_TO_SAVE";
    SaveState["RECENTLY_SAVED"] = "RECENTLY_SAVED";
    SaveState["SAVING"] = "SAVING";
})(SaveState || (SaveState = {}));
